const experiences = [
    {
      position: 'Web developer intern',
      company: 'Cognizant Technology Solutions',
      description:
        'Have built a Shopping application similar to Amazon with mern stack',
      year: 'December 2020-June 2021',
    },
    {
      position: 'Program Analyst Trainee',
      company: 'Cognizant Technology Solutions',
      description:
        "Responsible for creating and maintaining the client's website using React,HTML, CSS, Bootstrap and overlooked the implementation of accessibility to the entire application ",
      year: 'July 2021-February 2022',
    },
    {
      position: 'Associate Software Engineer',
      company: 'Global Logic',
      description:
        'Developing the UI for a dynamic full-stack application in Angular internal to Google along with proper test coverage using jasmine',
      year: 'March 2022-Present',
    },
  ];


  export default experiences;